import { render } from "./LoginSms.vue?vue&type=template&id=54e5a884&scoped=true&ts=true"
import script from "./LoginSms.vue?vue&type=script&lang=ts"
export * from "./LoginSms.vue?vue&type=script&lang=ts"

import "./LoginSms.vue?vue&type=style&index=0&id=54e5a884&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e5a884"]])

export default __exports__